<template>
    <div>
        <button :id="`select-button-${costTypeId}`" @click="changeShowDropdownState" class="select-button">
            <span :id="`select-span-${costTypeId}`" class="pull-left">{{selectedOptionText}}</span>
            <font-awesome-icon :id="`select-icon-${costTypeId}`" icon="fa-solid fa-sort" />
        </button>
        
        <div v-if="showDropdownBox" class="dropdown-container">
            <b-form-input 
                v-model="searchValue" 
                :placeholder="$gettext('Search...')" 
                :id="`search-input-${costTypeId}`"
                class="search-input" />
            <div class="option-list">
                <div v-for="option in filteredOptions" v-bind:key="option.id" @click="selectOption(option)" class="option-text">
                    <span>{{option.number}} - {{option.name}}</span>
                    <span class="pull-right" style="padding-left: 10px">{{option.balance_or_vw}}</span>
                </div>
                <span v-if="!filteredOptions.length" class="no-results-message" v-translate>No results found</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "LedgerDropdownSearch",
    props: {
        options: {
            type: Array,
            default() {
                return []
            }
        },
        defaultOptionText: {
            type: String,
            default() {
                return "--"
            }
        },
        costTypeId: {
            type: Number,
            default() {
                return -1
            }
        }
    },
    data() {
        return {
            showDropdownBox: false,
            selectedOptionText: "--",
            searchValue: ""
        }
    },
    created() {
        this.selectedOptionText = this.defaultOptionText;
        window.addEventListener("click", this.closeEventListener);
    },
    destroyed() {
        window.removeEventListener("click", this.closeEventListener);
    },
    methods: {
            changeShowDropdownState() {
                this.showDropdownBox = !this.showDropdownBox;
            },
            selectOption(option) {
                this.selectedOptionText = option.name;
                this.$emit("optionSelected", option);
                this.changeShowDropdownState();
                this.searchValue = "";
            },
            closeEventListener(event) {
                if (event.target.id !== `select-button-${this.costTypeId}` 
                    && event.target.id !== `select-span-${this.costTypeId}` 
                    && event.target.id !== `select-icon-${this.costTypeId}`
                    && event.target.id !== `search-input-${this.costTypeId}`) {
                        this.showDropdownBox = false;
                }
            },
            clearData() {
                this.showDropdownBox = false;
                this.selectedOptionText = "--";
                this.searchValue = "";
            }
    },
    computed: {
        filteredOptions() {
            let filteredOptions = this.options.filter(option => {
                let name = option.name.toLowerCase();
                let search_value = this.searchValue.toLowerCase();
                return name.includes(search_value) || option.number.includes(this.searchValue);
            });
            return filteredOptions;
        }
    }
}
</script>
<style lang="scss" scoped>
.select-button {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.select-button:focus {
    color: #495057;
    background-color: #fff;
    border-color: #6ce2c5;
    outline: 0;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 0 0.2rem rgb(34 172 138 / 25%);
}
.search-input {
    margin: 10px;
    width: 94%;
}
.no-results-message {
    color: $colorEmptyList;
    padding: 10px;
}
.dropdown-container {
    position: absolute;
    font-size: 14px;
    padding: calc(15px / 2);
    border-radius: 12px;
    border-color: #e9e9e9;
    box-shadow: -5px 6px 6px #0000005c;
    background: #ffffff;
    z-index: 10;
    min-width: 400px;
}
.option-list {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 300px;
}
.option-text {
    padding-right: 10px;
    padding-left: 10px;
}
.option-text:hover {
    background: rgba(34, 172, 138, 0.07);
    color: #06926f;
}
</style>